import * as React from 'react';

interface IProps {
  width?: number;
  strokeColor?: string;
  fillColor?: string;
}

export default (props: IProps) => {
  const {width, strokeColor, fillColor} = props;

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 70 70"
      fill={fillColor ?? 'none'}
      xmlns="http://www.w3.org/2000/svg">
      <g id="Icon">
        <path
          id="Oval"
          d="M69.3731 35C69.3731 54.33 53.8434 70 34.6866 70C15.5297 70 0 54.33 0 35C0 15.67 15.5297 0 34.6866 0C53.8434 0 69.3731 15.67 69.3731 35Z"
          fill={strokeColor ?? '#0088FF'}
        />
        <path
          id="Vector"
          d="M22 18V52H48V35H33.1429V18H22ZM36.8571 18V30.75H48L36.8571 18Z"
          fill={strokeColor ?? '#FFFFFF'}
        />
      </g>
    </svg>
  );
};
